module.exports = __webpack_public_path__ + "img/logo.2ab6ac35.png";